import { render, staticRenderFns } from "./FormCustom.vue?vue&type=template&id=400cb372&scoped=true&"
import script from "./FormCustom.vue?vue&type=script&lang=js&"
export * from "./FormCustom.vue?vue&type=script&lang=js&"
import style0 from "./FormCustom.vue?vue&type=style&index=0&id=400cb372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400cb372",
  null
  
)

export default component.exports